export function helpHeroService(userData: any) {
  // Removed legacy Sichern/Sichern HelpHero integration
  // To implement Sichern onboarding tours in the future, initialize here.
  return;
}
